module.exports = __webpack_public_path__ + "static/media/Ogapharmacy Logo.87431f76.png";